import isHighContrastTheme from '%evp_theme/brandbook/appearance/isHighContrastTheme';
import { pickForHighContrast, SUBTLE_BORDER_COLOR } from '../highContrastSx';

export const POPPER_MIN_WIDTH = 280;
export const BLUR_CLOSE_DELAY_MS = 120;

export const INPUT_SX = {
    flex: 1,
    minWidth: 0,
    fontSize: { xs: '1rem', sm: '0.875rem' },
    color: 'text.primary',
    '& input': { padding: 0 },
    '& input::placeholder': { color: 'grey.400', opacity: 1 },
};

export const POPPER_SX = { zIndex: theme => theme.zIndex.modal + 1 };

export const PAPER_SX = {
    mt: 0.5,
    borderRadius: 2,
    boxShadow: '0 4px 18px rgba(0,0,0,0.12)',
    overflow: 'hidden',
};

export const LIST_SX = {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    maxHeight: 360,
    overflowY: 'auto',
    scrollPaddingBottom: '48px',
};

export const ITEM_BASE_SX = {
    px: 1.5,
    py: 1,
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    gap: 0.25,
    borderBottom: '1px solid',
    borderColor: SUBTLE_BORDER_COLOR,
    '&:last-of-type': { borderBottom: 'none' },
};

export const ITEM_ACTIVE_SX = { bgcolor: 'action.hover' };

export const STATUS_SX = {
    px: 1.5,
    py: 1,
    color: 'grey.600',
    fontSize: '0.875rem',
};

export const PRIMARY_TEXT_SX = { color: 'text.primary', fontWeight: 500 };
export const SECONDARY_TEXT_SX = { color: 'grey.600', fontSize: '0.75rem' };

export const SHOW_ALL_ITEM_SX = {
    position: 'sticky',
    bottom: 0,
    mt: '-1px',
    borderTop: '1px solid',
    borderColor: 'grey.100',
    bgcolor: 'background.paper',
};

function opaqueSelectionTint(theme) {
    const { bg } = theme.palette.selection;

    return isHighContrastTheme(theme) ? `linear-gradient(${bg}, ${bg})` : undefined;
}

export const SHOW_ALL_ITEM_ACTIVE_SX = {
    bgcolor: pickForHighContrast('background.paper', 'grey.100'),
    backgroundImage: opaqueSelectionTint,
};

export const SHOW_ALL_TEXT_SX = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 0.5,
    color: 'primary.main',
    fontWeight: 600,
};
